import common from './common.json';
import navigation from './navigation.json';
import forms from './forms.json';
import validation from './validation.json';
import errors from './errors.json';
import messages from './messages.json';
import pages from './pages.json';
import modals from './modals.json';
import tables from './tables.json';
import api from './api.json';
import legacy from './legacy.json';
import talk from './talk.json';

const ur = {
  common,
  navigation,
  forms,
  validation,
  errors,
  messages,
  pages,
  modals,
  tables,
  api,
  legacy,
  talk
};

export default ur;
